const ENVS = {
  PROD: 'production',
};

const Environment = class {
  static get isProduction() {
    return process.env.NODE_ENV === ENVS.PROD;
  }

  static get isDev() {
    return !Environment.isProduction;
  }

  static get isSafariDesktop() {
    return window.safari !== undefined;
  }

  static get isAppleIphone() {
    return /iPhone/.test(navigator?.userAgent);
  }
};

export default Environment;
